import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Thông tin chi tiết thủ tục nhập học", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_10 = { class: "breadcrumb-item text-muted" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "notice bg-light-danger rounded border-danger border border-dashed d-flex align-items-center flex-wrap gap-3 p-4 mb-5"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-slash-circle text-danger fs-2" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-gray-800 flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Phiếu nhập học này đã hủy"),
  /*#__PURE__*/_createTextVNode(" — ứng viên đã chuyển sang hồ sơ nhập học khác. Trang chỉ để "),
  /*#__PURE__*/_createElementVNode("b", null, "xem / truy vết"),
  /*#__PURE__*/_createTextVNode(", mọi chỉnh sửa đã bị khóa. ")
], -1)
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 1,
  class: "notice bg-light-success rounded border-success border border-dashed d-flex align-items-center flex-wrap gap-3 p-4 mb-5"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle text-success fs-2" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-gray-800 flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Hồ sơ đã hoàn tất nhập học"),
  /*#__PURE__*/_createTextVNode(" — đã sinh mã SV và đồng bộ SIS. Thông tin đã "),
  /*#__PURE__*/_createElementVNode("b", null, "khóa chỉnh sửa"),
  /*#__PURE__*/_createTextVNode("; vẫn in phiếu / gửi email báo phí / tiếp nhận hồ sơ giấy bình thường. ")
], -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_21 = { class: "flex-column flex-lg-row-auto w-100 w-xl-300px mb-10" }
const _hoisted_22 = { class: "card mb-4 mb-xl-8" }
const _hoisted_23 = { class: "card-body py-5" }
const _hoisted_24 = {
  key: 0,
  class: "d-flex flex-center flex-column mb-4"
}
const _hoisted_25 = { class: "symbol symbol-100px symbol-circle mb-3 position-relative" }
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  src: "/media/avatars/blank.png",
  alt: "avatar"
}
const _hoisted_28 = {
  key: 2,
  type: "button",
  class: "btn btn-icon btn-circle btn-primary shadow position-absolute",
  style: {"width":"32px","height":"32px","bottom":"0","right":"0"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_avatar_edit",
  title: "Chỉnh sửa ảnh"
}
const _hoisted_29 = { class: "svg-icon svg-icon-4 m-0" }
const _hoisted_30 = { class: "d-flex flex-center gap-2" }
const _hoisted_31 = ["disabled", "title"]
const _hoisted_32 = { class: "svg-icon svg-icon-3 m-0" }
const _hoisted_33 = ["disabled", "title"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", {
  class: "fw-bolder",
  style: {"font-size":"11px"}
}, "PDF", -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "svg-icon svg-icon-3 m-0" }
const _hoisted_37 = ["disabled", "title"]
const _hoisted_38 = { class: "svg-icon svg-icon-3 m-0" }
const _hoisted_39 = {
  key: 1,
  class: "bg-light-primary rounded p-4 mb-4"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "text-primary text-uppercase fw-bold fs-8 mb-3" }, "Tài khoản hệ thống", -1)
const _hoisted_41 = { class: "d-flex align-items-center mb-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted fw-semibold flex-shrink-0",
  style: {"width":"74px"}
}, "MSSV", -1)
const _hoisted_43 = { class: "fw-bolder text-gray-800" }
const _hoisted_44 = { class: "d-flex align-items-center mb-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted fw-semibold flex-shrink-0",
  style: {"width":"74px"}
}, "Email", -1)
const _hoisted_46 = {
  key: 0,
  class: "text-gray-800 text-break fs-8"
}
const _hoisted_47 = {
  key: 1,
  class: "d-flex gap-2 flex-wrap"
}
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted fw-semibold flex-shrink-0",
  style: {"width":"74px"}
}, "Mật khẩu", -1)
const _hoisted_50 = { class: "text-gray-800 fs-8" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-4" }, null, -1)
const _hoisted_52 = { class: "fs-7" }
const _hoisted_53 = { class: "d-flex flex-stack mb-3" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Mã hồ sơ", -1)
const _hoisted_55 = { class: "fw-bold text-gray-800 text-end" }
const _hoisted_56 = { class: "d-flex flex-stack mb-3" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Ngành", -1)
const _hoisted_58 = { class: "fw-bold text-gray-800 text-end" }
const _hoisted_59 = {
  key: 0,
  class: "d-flex flex-stack mb-3"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Loại đào tạo", -1)
const _hoisted_61 = { class: "fw-bold text-gray-800 text-end" }
const _hoisted_62 = { class: "d-flex flex-stack mb-3" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Điện thoại", -1)
const _hoisted_64 = { class: "fw-bold text-gray-800 text-end" }
const _hoisted_65 = { class: "d-flex flex-stack mb-3" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Email cá nhân", -1)
const _hoisted_67 = { class: "fw-bold text-gray-800 text-end text-break" }
const _hoisted_68 = { class: "d-flex flex-stack" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Ngày tạo", -1)
const _hoisted_70 = { class: "fw-bold text-gray-800 text-end" }
const _hoisted_71 = {
  class: "card mb-4 mb-xl-8",
  id: "inforPayment"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-primary mb-4 umt-subhead" }, "Thông tin thanh toán", -1)
const _hoisted_73 = { class: "fs-7" }
const _hoisted_74 = { class: "d-flex flex-stack mb-3" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Tổng tiền", -1)
const _hoisted_76 = { class: "fw-bold text-gray-800 text-end" }
const _hoisted_77 = {
  key: 0,
  class: "d-flex flex-stack mb-3"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Đã thanh toán", -1)
const _hoisted_79 = { class: "fw-bold text-gray-800 text-end" }
const _hoisted_80 = { class: "d-flex flex-stack mb-3" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Còn lại", -1)
const _hoisted_82 = { class: "fw-bold text-gray-800 text-end" }
const _hoisted_83 = { class: "d-flex flex-stack" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Hình thức", -1)
const _hoisted_85 = { class: "text-end" }
const _hoisted_86 = {
  key: 0,
  class: "separator separator-dashed my-4"
}
const _hoisted_87 = {
  key: 1,
  class: "fs-8 text-gray-600 fst-italic"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock-fill me-1" }, null, -1)
const _hoisted_89 = {
  key: 0,
  class: "card mb-4 mb-xl-8"
}
const _hoisted_90 = { class: "card-body py-4 notice bg-light-danger rounded border-danger border border-dashed d-flex align-items-center" }
const _hoisted_91 = { class: "svg-icon svg-icon-2 svg-icon-danger me-3 flex-shrink-0" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-semibold text-gray-800" }, "Số tiền đã thu khác với tổng tiền. Vui lòng kiểm tra lại!", -1)
const _hoisted_93 = { class: "card mb-4 mb-xl-8" }
const _hoisted_94 = { class: "card-body py-4 fs-7" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted text-uppercase fw-bold fs-8 mb-3" }, "Cập nhật gần nhất", -1)
const _hoisted_96 = { class: "d-flex flex-stack mb-2" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Chỉnh sửa bởi", -1)
const _hoisted_98 = { class: "fw-bold text-gray-800 text-end" }
const _hoisted_99 = { class: "d-flex flex-stack" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold flex-shrink-0 me-3" }, "Ngày chỉnh sửa", -1)
const _hoisted_101 = { class: "fw-bold text-gray-800 text-end" }
const _hoisted_102 = { class: "flex-lg-row-fluid ms-lg-8" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("span", null, "Vui lòng kiểm tra lại thông tin ưu đãi. Chương trình ưu đãi của bạn đã bị hết hạn!", -1)
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = { class: "bg-white rounded-top nav nav-tabs-custom gap-2 fw-semibold align-items-center" }
const _hoisted_106 = { class: "nav-item" }
const _hoisted_107 = { class: "nav-item" }
const _hoisted_108 = {
  key: 2,
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_109 = {
  class: "tab-pane bg-white rounded-bottom fade show active",
  id: "kt_customer_view_personal_tab1",
  role: "tabpanel"
}
const _hoisted_110 = {
  class: "tab-pane bg-white rounded-bottom fade",
  id: "kt_customer_view_personal_tab3",
  role: "tabpanel"
}
const _hoisted_111 = {
  class: "tab-pane bg-white rounded-bottom fade",
  id: "kt_customer_view_personal_tab4",
  role: "tabpanel"
}
const _hoisted_112 = {
  key: 0,
  class: "p-6 row g-5"
}
const _hoisted_113 = {
  key: 0,
  class: "col-xl-6 col-12"
}
const _hoisted_114 = { class: "card border border-gray-200 h-100" }
const _hoisted_115 = { class: "d-flex align-items-center justify-content-between gap-3 px-6 py-4 border-bottom border-gray-200" }
const _hoisted_116 = { class: "d-flex align-items-center" }
const _hoisted_117 = { class: "symbol symbol-40px me-3" }
const _hoisted_118 = { class: "symbol-label bg-light-success" }
const _hoisted_119 = { class: "svg-icon svg-icon-2 svg-icon-success m-0" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-6 text-gray-900" }, "Học bổng"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Trừ trực tiếp vào học phí của sinh viên")
], -1)
const _hoisted_121 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_122 = { class: "px-6 pt-2 pb-5 d-flex flex-column flex-grow-1" }
const _hoisted_123 = { class: "d-flex flex-stack py-3 border-bottom border-gray-200 border-dashed" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-7 me-3 flex-shrink-0" }, "Tên học bổng", -1)
const _hoisted_125 = { class: "fw-bold text-gray-900 text-end" }
const _hoisted_126 = { class: "d-flex flex-stack py-3 border-bottom border-gray-200 border-dashed" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-7 me-3 flex-shrink-0" }, "Học kỳ áp dụng", -1)
const _hoisted_128 = { class: "fw-bold text-gray-900 text-end" }
const _hoisted_129 = {
  key: 0,
  class: "d-block text-primary fs-8 fw-semibold"
}
const _hoisted_130 = { class: "d-flex flex-stack py-3" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-7 me-3 flex-shrink-0" }, "Tỷ lệ giảm", -1)
const _hoisted_132 = { class: "badge badge-light-success fs-7 fw-bolder" }
const _hoisted_133 = { class: "d-flex flex-stack align-items-center bg-light-success rounded p-4 mt-auto" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Giá trị học bổng", -1)
const _hoisted_135 = { class: "fw-bolder fs-3 text-success" }
const _hoisted_136 = {
  key: 1,
  class: "col-xl-6 col-12"
}
const _hoisted_137 = { class: "card border border-gray-200 h-100" }
const _hoisted_138 = { class: "d-flex align-items-center justify-content-between gap-3 px-6 py-4 border-bottom border-gray-200" }
const _hoisted_139 = { class: "d-flex align-items-center" }
const _hoisted_140 = { class: "symbol symbol-40px me-3" }
const _hoisted_141 = { class: "symbol-label bg-light-primary" }
const _hoisted_142 = { class: "svg-icon svg-icon-2 svg-icon-primary m-0" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-6 text-gray-900" }, "Ưu đãi"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Các khoản giảm học phí đã đăng ký")
], -1)
const _hoisted_144 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_145 = { class: "px-6 pt-2 pb-5 d-flex flex-column flex-grow-1" }
const _hoisted_146 = { class: "text-muted fs-7 me-3" }
const _hoisted_147 = {
  key: 0,
  class: "badge badge-light-primary fs-9 ms-2"
}
const _hoisted_148 = { class: "fw-bold text-gray-900 text-end text-nowrap" }
const _hoisted_149 = { class: "d-flex flex-stack align-items-center bg-light-success rounded p-4 mt-auto" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-800" }, "Tổng tiền được giảm", -1)
const _hoisted_151 = { class: "fw-bolder fs-3 text-success" }
const _hoisted_152 = {
  key: 1,
  class: "p-10 text-center"
}
const _hoisted_153 = { class: "svg-icon svg-icon-3x svg-icon-gray-300 mb-3" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-500 fw-semibold fs-6" }, "Hồ sơ chưa có ưu đãi hoặc học bổng", -1)
const _hoisted_155 = {
  class: "modal fade",
  id: "kt_modal_avatar_edit",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_156 = { class: "modal-dialog modal-dialog-centered mw-400px" }
const _hoisted_157 = { class: "modal-content" }
const _hoisted_158 = { class: "modal-header py-4" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("h3", { class: "modal-title fs-5" }, "Chỉnh sửa ảnh hồ sơ", -1)
const _hoisted_160 = {
  class: "btn btn-icon btn-sm btn-active-light-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_161 = { class: "svg-icon svg-icon-2" }
const _hoisted_162 = { class: "modal-body text-center py-6" }
const _hoisted_163 = { class: "symbol symbol-150px symbol-circle mb-4" }
const _hoisted_164 = ["src"]
const _hoisted_165 = { class: "btn btn-sm btn-light-primary" }
const _hoisted_166 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "form-text mt-2" }, "Cho phép: png, jpg, jpeg.", -1)
const _hoisted_168 = { class: "modal-footer py-3" }
const _hoisted_169 = {
  type: "button",
  class: "btn btn-sm btn-light",
  "data-bs-dismiss": "modal",
  ref: "avatarModalClose"
}
const _hoisted_170 = ["disabled"]
const _hoisted_171 = { key: 0 }
const _hoisted_172 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_WidgetComment = _resolveComponent("WidgetComment")!
  const _component_sync_info_banner = _resolveComponent("sync-info-banner")!
  const _component_AdminssionProceduresTab1 = _resolveComponent("AdminssionProceduresTab1")!
  const _component_AdmissionTicket = _resolveComponent("AdmissionTicket")!
  const _directive_permission = _resolveDirective("permission")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
          [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW, _ctx.Permission.DASHBOARD]]
        ]),
        _hoisted_9,
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: "/danhsachthutucnhaphoc",
            class: "text-muted text-hover-primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Danh sách thủ tục nhập học ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-light ms-auto umt-btn-32",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_11,
        _createTextVNode("Quay lại ")
      ])
    ]),
    (_ctx.dataCustomer?.status == 'cancel')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _hoisted_14,
          (_ctx.activeApplicantId)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: `/danhsachthutucnhaphoc/${_ctx.activeApplicantId}`,
                class: "btn btn-sm btn-danger text-nowrap"
              }, "Mở phiếu đang hoạt động →", 8, _hoisted_15))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.dataCustomer?.status == 'confirmed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_ctx.dataCustomer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    (_ctx.dataCustomer?.avatar)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.dataCustomer.avatar,
                          alt: "avatar"
                        }, null, 8, _hoisted_26))
                      : (_openBlock(), _createElementBlock("img", _hoisted_27)),
                    (_ctx.dataCustomer?.status != 'cancel')
                      ? (_openBlock(), _createElementBlock("button", _hoisted_28, [
                          _createElementVNode("span", _hoisted_29, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_router_link, {
                    to: `/danhsachungvien/${_ctx.dataCustomer?.studentId}`,
                    class: "fs-4 fw-bolder text-gray-900 text-hover-primary text-center mb-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`${_ctx.dataCustomer?.familyName} ${_ctx.dataCustomer?.middleName} ${_ctx.dataCustomer?.givenName}`), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createElementVNode("span", {
                    class: _normalizeClass(`badge badge-light-${_ctx.statusTag.find(e=>e.code==_ctx.dataCustomer?.status)?.state} mb-4`)
                  }, _toDisplayString(_ctx.statusTag.find(e=>e.code==_ctx.dataCustomer?.status)?.label), 3),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-icon btn-light-primary",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.actionPrinter && _ctx.actionPrinter(...args))),
                      disabled: !_ctx.dataCustomer?.studentCode || _ctx.dataCustomer?.status == 'cancel',
                      title: !_ctx.dataCustomer?.studentCode ? 'Chưa có MSSV — chưa in được phiếu' : 'In phiếu thông tin sinh viên'
                    }, [
                      _createElementVNode("span", _hoisted_32, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/printer.svg" })
                      ])
                    ], 8, _hoisted_31),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-icon btn-light-primary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.actionExportPdf && _ctx.actionExportPdf(...args))),
                      disabled: !_ctx.dataCustomer?.studentCode || _ctx.dataCustomer?.status == 'cancel',
                      title: !_ctx.dataCustomer?.studentCode ? 'Chưa có MSSV — chưa tải được phiếu' : 'Tải PDF Phiếu thông tin sinh viên'
                    }, _hoisted_35, 8, _hoisted_33),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-icon btn-light-primary",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.actionDownload && _ctx.actionDownload(...args))),
                      title: "Tải hồ sơ (ZIP)"
                    }, [
                      _createElementVNode("span", _hoisted_36, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/downloadFile.svg" })
                      ])
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-icon btn-light-primary",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.actionSync && _ctx.actionSync(...args))),
                      disabled: _ctx.dataCustomer?.status == 'cancel',
                      title: _ctx.dataCustomer?.status == 'cancel' ? 'Phiếu đã hủy — không đẩy SIS' : 'Đẩy qua SIS'
                    }, [
                      _createElementVNode("span", _hoisted_38, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr032.svg" })
                      ])
                    ], 8, _hoisted_37)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.dataCustomer?.studentCode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.dataCustomer?.studentCode), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    (_ctx.dataCustomer?.email && _ctx.dataCustomer?.email!='')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.dataCustomer?.email), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("span", {
                            class: "btn btn-primary btn-sm py-1 px-2 fs-9",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.generalEmail())),
                            title: "Gửi yêu cầu IT tạo email sinh viên trên Azure"
                          }, "Tạo email sinh viên")
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.dataCustomer?.password), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.dataCustomer?.admissionRegistration.profileCode), 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.dataCustomer?.major), 1)
              ]),
              (_ctx.dataCustomer?.programtype)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _hoisted_60,
                    _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.programType[_ctx.dataCustomer?.programtype]), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.dataCustomer?.contactMobile), 1)
              ]),
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.dataCustomer?.contactEmail), 1)
              ]),
              _createElementVNode("div", _hoisted_68, [
                _hoisted_69,
                _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.moment(_ctx.dataCustomer?.createdAt)), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("div", {
            class: _normalizeClass(["card-body py-5", +_ctx.paidBy!=0 && (_ctx.total - (+_ctx.paidBy) - Number(_ctx.dataPreReceipt?_ctx.dataPreReceipt.totalPreReceipt: 0)) != 0?'notice bg-light-warning rounded border-warning border border-dashed':''])
          }, [
            _hoisted_72,
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.total.toLocaleString('vi-VN')), 1)
              ]),
              (_ctx.dataPreReceipt.totalPreReceipt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("span", _hoisted_79, _toDisplayString((_ctx.dataPreReceipt.totalPreReceipt + +_ctx.paidBy)?.toLocaleString('vi-VN')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_80, [
                _hoisted_81,
                _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.totalPaidLast()), 1)
              ]),
              _createElementVNode("div", _hoisted_83, [
                _hoisted_84,
                _createElementVNode("div", _hoisted_85, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paidByStatus, (item, index) => {
                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(`badge badge-light-${_ctx.statusReceipt[item]?.state}`)
                      }, _toDisplayString(_ctx.statusReceipt[item]?.label), 3),
                      _createTextVNode(" " + _toDisplayString(index >= _ctx.paidByStatus.length - 1?'':' | '), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (_ctx.dataCustomer?.open === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86))
              : _createCommentVNode("", true),
            (_ctx.dataCustomer?.open === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                  _hoisted_88,
                  _createTextVNode("Đã chuyển giao SIS — số tiền tính theo phiếu thu gắn hồ sơ ứng viên. Khoản thu sau khi SIS tạo hồ sơ sinh viên không về đây; đối chiếu công nợ tại SIS. ")
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        (+_ctx.paidBy!= 0 && _ctx.checkNumber)
          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("span", _hoisted_91, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                ]),
                _hoisted_92
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataCustomer)
          ? (_openBlock(), _createBlock(_component_WidgetComment, {
              key: 1,
              class: "mb-5 mb-xl-8",
              idStudent: _ctx.dataCustomer.studentId
            }, null, 8, ["idStudent"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, [
            _hoisted_95,
            _createElementVNode("div", _hoisted_96, [
              _hoisted_97,
              _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.dataCustomer?.lastModifiedBy?.split('_')[0]), 1)
            ]),
            _createElementVNode("div", _hoisted_99, [
              _hoisted_100,
              _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.moment(_ctx.dataCustomer?.updatedAt)), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_102, [
        (_ctx.dataCustomer && _ctx.dataCustomer.status !== 'cancel')
          ? (_openBlock(), _createBlock(_component_sync_info_banner, {
              key: 0,
              "applicant-id": _ctx.dataCustomer.id,
              "can-sync": _ctx.dataCustomer.status !== 'confirmed',
              "show-match-note": false,
              onSynced: _ctx.onSyncedDetail
            }, null, 8, ["applicant-id", "can-sync", "onSynced"]))
          : _createCommentVNode("", true),
        (_ctx.expiredPromotion)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["w-100 notice fw-bolder rounded border border-dashed p-6 mb-6", _ctx.dataReceipt?'bg-light-warning border-warning':'text-white bg-danger border-danger'])
            }, _hoisted_104, 2))
          : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_105, [
          _createElementVNode("li", _hoisted_106, [
            _createElementVNode("a", {
              class: "nav-link btn btn-active-light-primary btn-color-gray-600 fw-semibold fs-6 px-4 py-2 active",
              "data-bs-toggle": "tab",
              href: "#kt_customer_view_personal_tab1",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isTabs3 = false))
            }, "Thông tin nhập học")
          ]),
          _createElementVNode("li", _hoisted_107, [
            _createElementVNode("a", {
              class: "nav-link btn btn-active-light-primary btn-color-gray-600 fw-semibold fs-6 px-4 py-2",
              "data-bs-toggle": "tab",
              href: "#kt_customer_view_personal_tab3",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isTabs3 = false))
            }, "Phiếu tiếp nhận hồ sơ")
          ]),
          _createElementVNode("li", {
            class: _normalizeClass(["nav-item", _ctx.dataCustomer?.freeTuitionRegistration && _ctx.dataCustomer?.freeTuitionRegistration[0]?.registrationType !='scholarships' && _ctx.dataCustomer?.status == 'confirmed'?'':'disabled1'])
          }, [
            _createElementVNode("a", {
              class: "nav-link btn btn-active-light-primary btn-color-gray-600 fw-semibold fs-6 px-4 py-2",
              "data-bs-toggle": "tab",
              href: "#kt_customer_view_personal_tab4",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isTabs3 = false))
            }, "Xác nhận ưu đãi/học bổng")
          ], 2)
        ]),
        (_ctx.dataCustomer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                _createVNode(_component_AdminssionProceduresTab1, {
                  onCallBackFunction: _ctx.reloadData,
                  dataReceipt: _ctx.dataReceipt,
                  dataInitial: _ctx.dataCustomer
                }, null, 8, ["onCallBackFunction", "dataReceipt", "dataInitial"])
              ]),
              _createElementVNode("div", _hoisted_110, [
                _createVNode(_component_AdmissionTicket, {
                  dataReceipt: _ctx.dataReceipt,
                  dataInitial: _ctx.dataCustomer
                }, null, 8, ["dataReceipt", "dataInitial"])
              ]),
              _createElementVNode("div", _hoisted_111, [
                ((_ctx.dataCustomer?.freeTuitionRegistration && _ctx.dataCustomer?.freeTuitionRegistration?.find(i=> i.registrationType =='scholarships')) || _ctx.promotionLines.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                      (_ctx.dataCustomer?.freeTuitionRegistration && _ctx.dataCustomer?.freeTuitionRegistration?.find(i=> i.registrationType =='scholarships'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                            _createElementVNode("div", _hoisted_114, [
                              _createElementVNode("div", _hoisted_115, [
                                _createElementVNode("div", _hoisted_116, [
                                  _createElementVNode("span", _hoisted_117, [
                                    _createElementVNode("span", _hoisted_118, [
                                      _createElementVNode("span", _hoisted_119, [
                                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/finance/fin001.svg" })
                                      ])
                                    ])
                                  ]),
                                  _hoisted_120
                                ]),
                                (_ctx.dataCustomer?.status != 'cancel')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "btn btn-sm btn-light-primary text-nowrap",
                                      title: "In phiếu xác nhận học bổng",
                                      onClick: _cache[9] || (_cache[9] = e=>_ctx.printInfo(_ctx.dataCustomer?.freeTuitionRegistration?.find(i=> i.registrationType =='scholarships'), 1))
                                    }, [
                                      _createElementVNode("span", _hoisted_121, [
                                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/printer.svg" })
                                      ]),
                                      _createTextVNode(" In phiếu ")
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_122, [
                                _createElementVNode("div", _hoisted_123, [
                                  _hoisted_124,
                                  _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.dataCustomer?.freeTuitionRegistration?.find(i=> i.registrationType =='scholarships')?.scholarships?.name), 1)
                                ]),
                                _createElementVNode("div", _hoisted_126, [
                                  _hoisted_127,
                                  _createElementVNode("span", _hoisted_128, [
                                    _createTextVNode(_toDisplayString(_ctx.dataCustomer?.freeTuitionRegistration?.find(i=> i.registrationType =='scholarships')?.scholarships?.releasedIn) + " học kỳ ", 1),
                                    (_ctx.dataCustomer.Student && _ctx.dataCustomer.Student?.isstaffchild || _ctx.dataCustomer.Student?.ispartnerchild)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_129, "+ " + _toDisplayString(+_ctx.dataCustomer.Student.personnelchild/100) + " (cộng đồn " + _toDisplayString(`${_ctx.dataCustomer.Student?.isstaffchild?'là con đối tác':'là con của nhân viên, giảng viên'}`) + ")", 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_130, [
                                  _hoisted_131,
                                  _createElementVNode("span", _hoisted_132, _toDisplayString(((_ctx.dataCustomer?.freeTuitionRegistration?.find(i=> i.registrationType =='scholarships')?.scholarships?.discount || 0) * 100).toFixed(0)) + "% học phí", 1)
                                ]),
                                _createElementVNode("div", _hoisted_133, [
                                  _hoisted_134,
                                  _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.dataCustomer?.freeTuitionRegistration?.find(i=> i.registrationType =='scholarships')?.scholarships?.value?.toLocaleString('vi-VN')) + " đ", 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.promotionLines.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                            _createElementVNode("div", _hoisted_137, [
                              _createElementVNode("div", _hoisted_138, [
                                _createElementVNode("div", _hoisted_139, [
                                  _createElementVNode("span", _hoisted_140, [
                                    _createElementVNode("span", _hoisted_141, [
                                      _createElementVNode("span", _hoisted_142, [
                                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/finance/fin010.svg" })
                                      ])
                                    ])
                                  ]),
                                  _hoisted_143
                                ]),
                                (_ctx.dataCustomer?.status != 'cancel' && _ctx.dataCustomer?.orderDetails?.promotion)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "btn btn-sm btn-light-primary text-nowrap",
                                      title: "In phiếu xác nhận ưu đãi",
                                      onClick: _cache[10] || (_cache[10] = e=>_ctx.printInfo(_ctx.dataCustomer?.orderDetails?.promotion, 2))
                                    }, [
                                      _createElementVNode("span", _hoisted_144, [
                                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/printer.svg" })
                                      ]),
                                      _createTextVNode(" In phiếu ")
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_145, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionLines, (p, pi) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: pi,
                                    class: _normalizeClass(["d-flex flex-stack py-3", { 'border-bottom border-gray-200 border-dashed': pi < _ctx.promotionLines.length - 1 }])
                                  }, [
                                    _createElementVNode("span", _hoisted_146, [
                                      _createTextVNode(_toDisplayString(p.name), 1),
                                      (p.percent)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_147, _toDisplayString(p.percent) + "%", 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("span", _hoisted_148, "- " + _toDisplayString(p.amount.toLocaleString('vi-VN')) + " đ", 1)
                                  ], 2))
                                }), 128)),
                                _createElementVNode("div", _hoisted_149, [
                                  _hoisted_150,
                                  _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.promotionLinesTotal.toLocaleString('vi-VN')) + " đ", 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!(_ctx.dataCustomer?.freeTuitionRegistration && _ctx.dataCustomer?.freeTuitionRegistration?.find(i=> i.registrationType =='scholarships')) && !_ctx.promotionLines.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                      _createElementVNode("span", _hoisted_153, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/finance/fin001.svg" })
                      ]),
                      _hoisted_154
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_155, [
      _createElementVNode("div", _hoisted_156, [
        _createElementVNode("div", _hoisted_157, [
          _createElementVNode("div", _hoisted_158, [
            _hoisted_159,
            _createElementVNode("div", _hoisted_160, [
              _createElementVNode("span", _hoisted_161, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_162, [
            _createElementVNode("div", _hoisted_163, [
              _createElementVNode("img", {
                src: _ctx.avatarPreview || _ctx.dataCustomer?.avatar || '/media/avatars/blank.png',
                alt: "avatar"
              }, null, 8, _hoisted_164)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_165, [
                _createElementVNode("span", _hoisted_166, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil022.svg" })
                ]),
                _createTextVNode(" Chọn ảnh "),
                _createElementVNode("input", {
                  type: "file",
                  accept: ".png,.jpg,.jpeg",
                  class: "d-none",
                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onAvatarPick && _ctx.onAvatarPick(...args)))
                }, null, 32)
              ])
            ]),
            _hoisted_167
          ]),
          _createElementVNode("div", _hoisted_168, [
            _createElementVNode("button", _hoisted_169, "Huỷ", 512),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-primary",
              disabled: !_ctx.avatarPreview || _ctx.savingAvatar,
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.saveAvatar && _ctx.saveAvatar(...args)))
            }, [
              (!_ctx.savingAvatar)
                ? (_openBlock(), _createElementBlock("span", _hoisted_171, "Lưu ảnh"))
                : (_openBlock(), _createElementBlock("span", _hoisted_172, "Đang lưu..."))
            ], 8, _hoisted_170)
          ])
        ])
      ])
    ])
  ])), [
    [_directive_permission, [_ctx.Permission.APPLICANT_VIEW_DETAIL, _ctx.Permission.APPLICANT]]
  ])
}